import React, { Component } from 'react'

export class InvalidEvent extends Component {
    render() {
        return (
            <div>

            </div>
        )
    }
}

export default InvalidEvent
